export default __webpack_public_path__ + "static/media/underdogdevWebsite.c4405cc6.png";